module.exports = "https://cdn.thelire.com/ins/resource/ico_coinstore_watch&earn@3x.830793d6c074f9cf636a83b948421a30.png";